import { getAuthAxiosBackend } from "@/helpers/axios"

class TypeInjuriesServices{

    get(id){
        return getAuthAxiosBackend().get('TypesInjuries/getTypesInjuriesById/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('TypesInjuries/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('TypesInjuries/addTypesInjuries', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('TypesInjuries/updateTypesInjuries/'+id, data)
    }

    restore(id, data){
        return getAuthAxiosBackend().put('TypesInjuries/restoreTypesInjuries/'+id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('TypesInjuries/softDeleteTypesInjuries/' + id.toString())
    }
    
    forceDelete(id){
        return getAuthAxiosBackend().delete('TypesInjuries/deleteTypesInjuries/' + id.toString())
    }
}

export default new TypeInjuriesServices()